<section >
    <header class="graph-date-controls pie-chart-header">
        <div>
            <p class="single-month-chart-header">Incident Upload Status</p>
            <p class="current-month-label" [style.visibility]="isShowingCurrentMonth ? 'visible' : 'hidden'">(Current Month)</p>
        </div>
        <date-selector (selectedDateChange)="startDate = $event" [selectedDate]="startDate" [startDate]="earliestSelectionDate" [endDate]="latestSelectionDate"/>
    </header>
    <div class="pie-chart-container" [style.width.px]="chartSize[0]">
        <ngx-charts-pie-chart
            [results]="pieData"
            [view]="chartSize"
            [legend]="false"
            [labels]="true"
            [doughnut]="true"
            [explodeSlices]="false"
            [legend]="showLegend"
            [scheme]="customColorsSchema"
            [trimLabels]="false"
            [margins]="chartMargins"
        >
        </ngx-charts-pie-chart>
        <div class="pie-chart-center">
            <p>{{ total }}</p>
        </div>
    </div>
</section>